import {fromJson, URL_BASE_AUTH} from "../utils/helper.js";


class TeamMember {


    constructor() {

        this.id = null;
        this.staff_id = null;
        this.is_leader = 0

    }


    static fromJson(object) {
        return fromJson((new TeamMember()), object);
    }

}

export default TeamMember;
